import { combineReducers } from "redux";
import apiReducer from "./apiReducer";
import userReducer from "./userReducer";
import configurationReducer from "./configurationReducer";
import executiveOverviewReducer from "./executiveOverviewReducer";
import programReducer from "./programReducer";

const rootReducer = combineReducers({
  api: apiReducer,
  user: userReducer,
  configuration: configurationReducer,
  executiveOverview: executiveOverviewReducer,
  program: programReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
